import { Backdrop, CircularProgress, Grid, Slide, Stack } from '@mui/material';
import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';

import useAuth from '../../auth/useAuth';
import { LayoutContext } from '../LayoutPreference/layoutTypes';
import MenuLegacy from '../menu/MenuLegacy';

/** @deprecated Temporary dual-layout rollout legacy shell. Remove when legacy layout is retired. */
const AuthenticatedLegacy = () => {
  const { isAuthenticated, isReadyForAuthorization, isPasswordExpired } =
    useAuth();
  const { pathname, search } = useLocation();

  const [openMobile, setOpenMobile] = useState<boolean>(false);

  if (!isAuthenticated()) {
    return (
      <Navigate
        to={BASE.AUTH.LOGIN}
        state={{ from: { pathname, search } }}
        replace
      />
    );
  } else if (isPasswordExpired()) {
    return <Navigate to={BASE.AUTH.CHANGE_EXPIRED_PASSWORD} replace />;
  }

  if (!isReadyForAuthorization()) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }

  return (
    <Grid container columns={16}>
      {/* Menu Section */}
      <Slide direction="right" in mountOnEnter unmountOnExit>
        <Grid
          size={{
            lg: 2,
          }}
        >
          <MenuLegacy
            open={openMobile}
            menuItemClick={() => setOpenMobile(false)}
          />
        </Grid>
      </Slide>
      <Grid sx={{ height: '100vh', overflowY: 'auto', margin: 0 }} size="grow">
        <Stack sx={{ height: '100%' }}>
          <Outlet
            context={
              {
                setOpenMobile,
              } as LayoutContext
            }
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default AuthenticatedLegacy;
